import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ErrorLabelDirective } from '@shared/directives';

import { Logger } from '@core/utils';

import { AlertService } from '@shared/services';
import { UntilDestroy } from '@ngneat/until-destroy';

const log = new Logger('Motivo Modal');

@UntilDestroy()
@Component({
  selector: 'app-motivo-modal',
  imports: [ReactiveFormsModule, ErrorLabelDirective, NgClass],
  templateUrl: './motivo-modal.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MotivoModalComponent {
  private readonly alertService = inject(AlertService);
  readonly activeModal = inject(NgbActiveModal);

  @Input() title = 'Motivo';
  @Input() label = 'Describe los motivos de esta acción';
  @Input() btnText = 'Observar';
  @Input() btnColor = 'base';
  @Input() isRequired = true;

  motivoForm = new FormGroup({
    motivo: new FormControl<string | null>(null, Validators.required),
  });

  observar() {
    log.info('saveOrUpdate', this.motivoForm.value);
    this.motivoForm.markAllAsTouched();
    if (this.motivoForm.invalid) {
      this.alertService.showMessageCustom('Campos obligatorios', 'Es necesario completar los campos obligatorios (*)', {
        icon: 'brightness_alert',
        class: 'text-warning',
      });
      return;
    }

    this.activeModal.close(this.motivoForm.get('motivo')?.value);
  }

  longitudCampo(campo: string): number {
    const valor = this.motivoForm.get(campo)?.value;
    return valor ? valor.length : 0;
  }
}